/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { getCartState } from '@msdyn365-commerce/global-state';
import { fetchPersistCartChanges, IVSICompareCartDataResponse } from '../utilities/persist-cart-utils';

export class CartItemsChangesInput implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `cartItemsChangesKey`;
    public getCacheObjectType = () => 'cartItemsChangesState';
    public dataCacheType = (): CacheType => 'none';
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new CartItemsChangesInput();
};

export async function getCartItemsChangesAction(input: CartItemsChangesInput, ctx: IActionContext): Promise<IVSICompareCartDataResponse> {
    const cartState = await getCartState(ctx);
    const cartComparisonObj = await fetchPersistCartChanges(cartState.cart.Id, ctx);
    return cartComparisonObj;
}

export default createObservableDataAction<IVSICompareCartDataResponse>({
    action: <IAction<IVSICompareCartDataResponse>>getCartItemsChangesAction,
    input: createInput
});
